import React, {useEffect, useState, useContext } from "react";
import './header.styles.scss';
import {Link} from "gatsby";
import {AnchorLink } from 'gatsby-plugin-anchor-links';
import Hamburger from "../hamburger/hamburger.component";
import cart from "../../assets/images/cart.png";
import { GlobalStateContext } from '../../context/globalContextProvider';

const Header = () => {
    const { items } = useContext(GlobalStateContext);
    const [isScrolling, setIsScrolling] = useState('top')
    const [itemAmount, setItemAmount] = useState(0)

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);

        return() => {
            window.removeEventListener('scroll', handleScroll)
        }
    }, []);

    useEffect(() => {
        const amount = items.reduce((amount, curr) => {
            amount += Number(curr.qty);
            return amount
        }, 0);
        setItemAmount(amount);

    }, [JSON.stringify(items)])
    

    const handleScroll = async () => {

        if (window.scrollY === 0) {
            await setIsScrolling('top')
        } else {
            await setIsScrolling('scrolling')

        }
    }


    return (
        <>
            <div className="no-hamburger">
            

                <div className={
                    isScrolling === 'top' ? "header-container" : "header-container-small"
                }>
                    <ul>
                        <Link className="neon" activeClassName="active" to="/" data-text="HOME">HOME</Link>
                        <Link className="neon" activeClassName="active" to="/vocal-samples" data-text="VOCAL SAMPLES">VOCAL SAMPLES</Link>
                        <Link className="neon" activeClassName="active" to="/work" data-text="WORK">WORK</Link>
                        <AnchorLink className="neon" data-text="SAY HI" to="/#contact">SAY HI</AnchorLink>
                    </ul>
                    {
                        itemAmount > 0 &&
                            <div className="cart">
                            <Link to="/cart">
                                <img src={cart} />
                                <div className="cart-amount">
                                    <h2>{itemAmount}</h2>
                                </div>
                                
                            </Link>
                        </div>
                    }
                   
                    
                </div>
                {
                isScrolling === 'top' ? <div className="spacer"></div> : <div className="spacer-small"></div>
            } 
          
            </div>
        
            

            <div className="hamburger">
                <Hamburger />
               
            </div>
           
            <div className="spacer-small"></div>


        </>
    )
}

export default Header;
